import 'app/i18n'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap'

import React, { Suspense } from 'react'
import 'react-awesome-lightbox/build/style.css'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import AppMaritime from 'app/components/AppMaritime'
import Loading from 'app/components/Common/Loading'

import './App.scss'
import store from './app/store'

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<Loading isOpen={false} />}>
          <AppMaritime />
        </Suspense>
      </BrowserRouter>
    </Provider>
  )
}

export default App
